import * as React from 'react';
import { MouseEvent } from 'react';
import styled from '@emotion/styled';

export interface PillWidgetProps {
  label: string;
  color?: string;
  borderColor?: string;
  action?: (event: React.MouseEvent) => any;
  rightClick?: (event: MouseEvent) => any;
  meta?: {
    label?: string;
    icon?: JSX.Element;
  };
}

namespace S {
  const RADIUS = 5;

  export const Container = styled.div<{ color: string; borderColor?: string }>`
    padding: 2px;
    border-radius: ${RADIUS}px;
    background: ${(p) => p.color};
    border: ${(p) => (p.borderColor ? `1px solid ${p.borderColor}` : 'none')};
    overflow: hidden;
    font-size: 12px;
    display: flex;
    align-items: center;
  `;

  export const Label = styled.div<{ hasIcon: boolean }>`
    background: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.8);
    border-top-right-radius: ${(p) => (p.hasIcon ? 0 : RADIUS)}px;
    border-bottom-right-radius: ${(p) => (p.hasIcon ? 0 : RADIUS)}px;
    padding: 2px 5px;
    white-space: nowrap;
    flex-shrink: 0;
  `;

  export const Meta = styled.div`
    padding-left: 5px;
    color: black;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    > * {
      padding-right: 5px;
    }
  `;

  export const MetaLabel = styled.div``;
}

export const PillWidget: React.FC<PillWidgetProps> = (props) => {
  return (
    <S.Container
      onClick={(event) => {
        props.action?.(event);
      }}
      onContextMenu={(event) => {
        event.preventDefault();
        event.stopPropagation();
        event.persist();
        props.rightClick?.(event);
      }}
      color={props.color || 'rgb(150,150,150)'}
      borderColor={props.borderColor}
    >
      <S.Label hasIcon={!!props.meta}>{props.label}</S.Label>
      {props.meta ? (
        <S.Meta>
          {props.meta.icon}
          {props.meta.label ? <S.MetaLabel>{props.meta.label}</S.MetaLabel> : null}
        </S.Meta>
      ) : null}
    </S.Container>
  );
};
